import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTiposMovimentos() {
        return axiosJwt
            .get(`${api}/tiposmovimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    salvar(tipoMovimento) {
        return axiosJwt
            .post(`${api}/tiposmovimentos`, tipoMovimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTipoMovimento(codMov) {
        return axiosJwt
            .get(`${api}/tiposmovimentos/${codMov}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoes() {
        return axiosJwt
            .get(`${api}/tiposmovimentos/opcoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumento(documento) {
        const formData = new FormData()
        formData.append('codMov', documento.codMov)
        formData.append('tipo', documento.tipo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt
            .post(
                `${api}/tiposmovimentos/${documento.codMov}/upload`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumento(documento) {
        return axiosJwt
            .get(
                `${api}/tiposmovimentos/${documento.codMov
                }/download/${documento.tipo}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirTipoMovimento(codMov) {
        return axiosJwt
            .delete(`${api}/tiposmovimentos/${codMov}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
